<era-pairing-code-ui [code]="code$ | async"></era-pairing-code-ui>